import type { DbUserAccount } from '~~/types/account.types'
import type { Database } from '~~/types/database.types'

// TODO?: Use cache data with useNuxtData(`user-accounts-${userId}`), and add parameter to force refresh (after importing updated broker data)

export async function useUserAccounts(forceRefresh: boolean = false): Promise<Ref<DbUserAccount[]>> {
  // Setting up the needed composables
  const supabaseClient = useSupabaseClient<Database>()
  const user = useSupabaseUser()
  const userId = user.value?.sub

  // Getting the user accounts from cache and returning it if it's available
  const { data: cacheData } = useNuxtData<DbUserAccount[]>(`user-accounts-${userId}`)
  if (cacheData.value !== null && cacheData.value !== undefined && !forceRefresh) {
    console.log('useUserAccounts send cache data', cacheData.value)
    return cacheData as Ref<DbUserAccount[]>
  }

  // Getting all the user accounts from database
  const { data: newUserAccounts, error: errorUserAccounts } = await supabaseClient
    .from('user_accounts')
    .select('*')

  // Updating the cache data
  cacheData.value = newUserAccounts ?? []

  // Managing the error
  if (errorUserAccounts !== null || newUserAccounts === null) {
    console.error('Error selecting user accounts', errorUserAccounts)
    useCustomError({
      error: new DatabaseError(DatabaseErrorCodes.SELECT_USER_ACCOUNTS_IMPOSSIBLE, { props: { errorCause: errorUserAccounts }}),
      cause: errorUserAccounts,
      data: { userId },
      reportToSentry: true,
      reportToUser: true
    })
  }

  // Returning the user accounts
  return cacheData as Ref<DbUserAccount[]>
}